import { Link, useNavigate } from "react-router-dom";
import { StaticImage } from "../../utils/image";
import { useDispatch, useSelector } from "react-redux";
import { UsersData } from "../../data/users";
import React, { useState } from "react";
import ApiAccount from "../../api/ApiAccount";
import CSwl from "../../utils/alert";
import ApiUser from "../../api/ApiUser";
import { setLocalStorage } from "../../utils/localStorage";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
} from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { validateNumber, validatePhonenumber } from "../../utils";
import { useTranslation } from 'react-i18next';
const LoginSuccess = () => {
    const { t } = useTranslation();
    const { instance, accounts, inProgress } = useMsal();
    const [loginChannel, setLoginChannel] = useState(0);
    const [state, setstate] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        newPassword: "",
        driverName: "",
        messageError: "",
        showLogin: true,
        showRegister: false,
        showChangePassword: false,
        adminLogin: false,
        userList: [],
        officerCode: "",
        phoneNumber: "",
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();

    React.useEffect(() => {
        if (isAuthenticated) {
            const username = accounts[0] && accounts[0].username;
            var model = {
                email: username,
            };
            loginAD(model);
        } else {
        }
    }, [isAuthenticated]);

    const loginAD = async (model) => {
        CSwl.SwalLoad();
        let response = {};
        response = await ApiAccount.loginAD({
            "officerCode": "",
            "officerPassword": "",
            "officerEmail": model.email,
            "truckid": "",
            "drivername": "",
            "truckName": "",
            "trucktype": "",
            "roleid": "",
            "contractId": ""
        });
        if (response.status == 200) {
            if (response.data.value.isAdmin) {
                setLoginChannel(1);
                setstate({ ...state, adminLogin: true, userList: response.data.value.users })
                CSwl.SwalClose();
            } else {
                setstate({ ...state, adminLogin: false, userList: [] })
                setLocalStorage("token", response.data.value.token);
                const responseUser = await ApiUser.getProfile();
                if (responseUser.status == 200) {
                    dispatch({ type: "set", user: responseUser.data, token: response.data.value.token });
                    navigate('/');
                }
                CSwl.SwalClose();
            }
        } else if (response.status == 404) {
            sessionStorage.clear()
            CSwl.SwalClose();
            navigate('/login');
        } else {
            sessionStorage.clear()
            CSwl.SwalClose();
            setstate({ ...state, messageError: response.data });
            //CSwl.SwalErr(response.data);
        }
    }

    const navigateToHome = async (e) => {
        e.preventDefault();
        CSwl.SwalLoad();
        let response = {};

        if (state.adminLogin) {
            response = await ApiAccount.loginAs({
                "officerCode": state.email,
                "officerPassword": state.password,
                "LoginAs": state.officerCode
            });
        } else {
            response = await ApiAccount.login({
                "officerCode": state.email,
                "officerPassword": state.password,
                "truckid": "",
                "drivername": "",
                "truckName": "",
                "trucktype": "",
                "roleid": "",
                "contractId": ""
            });
        }

        if (response.status == 200) {
            if (response.data.value.isAdmin) {
                setstate({ ...state, adminLogin: true, userList: response.data.value.users })
                CSwl.SwalClose();
            } else {
                setstate({ ...state, adminLogin: false, userList: [] })
                setLocalStorage("token", response.data.value.token);
                const responseUser = await ApiUser.getProfile();
                if (responseUser.status == 200) {
                    dispatch({ type: "set", user: responseUser.data, token: response.data.value.token });
                    navigate('/');
                }
                CSwl.SwalClose();
            }
        } else if (response.status == 404) {
            CSwl.SwalClose();
            setstate({ ...state, showLogin: false, showRegister: true })
        } else {
            CSwl.SwalClose();
            if (response.data?.includes("Change Password")) {
                setstate({ ...state, showLogin: false, showChangePassword: true });
            }
            else {
                setstate({ ...state, messageError: response.data });
            }

            //CSwl.SwalErr(response.data);
        }
        // const user = UsersData.find(x => x.email == state.email && x.password == state.password);
        // if (!user) { setstate({ ...state, messageError: "Email or Password invalid", password: "" }); return false; }
        // else {
        //     setstate({ ...state, messageError: "" });
        //     dispatch({ type: "set", user: user });
        //     navigate('/');
        // }

    }

    const createNewAccount = async (e) => {
        e.preventDefault();
        CSwl.SwalLoad();
        const response = await ApiAccount.create({
            "officerCode": state.email,
            "password": state.password,
            "confirmPassword": state.confirmPassword,
            "driverName": state.driverName
        });
        if (response.status == 200) {
            CSwl.SwalClose();
            CSwl.SwalSuccess();
            setstate({ ...state, password: "", showLogin: true, showRegister: false, showChangePassword: false })
        } else {
            CSwl.SwalClose();
            setstate({ ...state, messageError: response.data });
            //CSwl.SwalErr(response.data);
        }
        // const user = UsersData.find(x => x.email == state.email && x.password == state.password);
        // if (!user) { setstate({ ...state, messageError: "Email or Password invalid", password: "" }); return false; }
        // else {
        //     setstate({ ...state, messageError: "" });
        //     dispatch({ type: "set", user: user });
        //     navigate('/');
        // }

    } 

    const changePassword = async (e) => {
        e.preventDefault();
        CSwl.SwalLoad();
        if (state.newPassword !== state.confirmPassword) {
            setstate({ ...state, messageError: t('login.confirmPasswordMismatch') });
            CSwl.SwalClose();
            return false;
        }
        const response = await ApiUser.changePassword({
            "officer_code": state.email,
            "oldPassword": state.password,
            "newPassword": state.newPassword,
        });
        if (response.status == 200) {
            CSwl.SwalClose();
            CSwl.SwalSuccess();
            setstate({ ...state, password: "", showLogin: true, showChangePassword: false })
        } else {
            CSwl.SwalClose();
            setstate({ ...state, messageError: response.data });
            //CSwl.SwalErr(response.data);
        }
        // const user = UsersData.find(x => x.email == state.email && x.password == state.password);
        // if (!user) { setstate({ ...state, messageError: "Email or Password invalid", password: "" }); return false; }
        // else {
        //     setstate({ ...state, messageError: "" });
        //     dispatch({ type: "set", user: user });
        //     navigate('/');
        // }

    }

    function handleLogin(instance) {
        instance.loginRedirect(loginRequest).catch(e => {
            console.error(e);
        });
    }

    function handleLogout(instance) {
        instance.logoutRedirect().catch(e => {
            console.error(e);
        });
    }

    return <>
        <form onSubmit={navigateToHome} className={`${state.showLogin ? "" : "hidden"}`}>
            <section className="h-screen">
                <div className="h-full bg-gradient-to-r from-blue to-blue-600 flex justify-center items-center">
                    <div className="p-5 bg-white rounded flex flex-col items-center">
                        {loginChannel != 0 && <span onClick={() => setLoginChannel(0)} className="text-base text-blue cursor-pointer self-start">{t('common.back')}</span>}

                        <div>
                            <img className="object-contain h-20 w-32" src={StaticImage('/images/logoSCGPSolidBlac-removebg-preview.png')} />
                        </div>
                        <div>
                            <h1 className="font-bold text-3xl">Sign in to your account</h1>
                        </div>
                        <span className="text-base text-gray">{t('login.welcome')}</span>
                        {
                            loginChannel == 0 && <div className="w-72 flex flex-col gap-y-3 mt-3">
                                <button onClick={() => handleLogin(instance)} type="button" className="btn-red w-72">SCG USER</button>
                                <button onClick={() => setLoginChannel(1)} type="button" className="btn-red w-72">PRIVATE USER</button>
                            </div>
                        }
                        {loginChannel == 1 &&
                            <>

                                <input value={state.email}
                                    onChange={(e) => {
                                        setstate({ ...state, email: e.target.value })
                                    }} required className="form-control w-72 mt-2" placeholder="Username" type="text" disabled={state.adminLogin} />
                                <input value={state.password}
                                    onChange={(e) => {
                                        setstate({ ...state, password: e.target.value })
                                    }} required className="form-control w-72 mt-1" placeholder="Password" type="password" disabled={state.adminLogin} />
                                {state.messageError && <label className="text-red">{state.messageError}</label>}
                                <select className={`form-control w-72 mt-1 border-b border-black mb-1 ${state.adminLogin ? "" : "hidden"}`}
                                    onChange={(e) => { setstate({ ...state, officerCode: e.target.value }) }}
                                >
                                    <option>Login As...</option>
                                    {
                                        state.userList.map((item, index) => {
                                            return (
                                                <option value={item}>{item}</option>
                                            )
                                        })
                                    }
                                </select>

                                <button type="submit" className="btn-red w-72 mt-2">Sign in</button>

                            </>
                        }
                    </div>
                </div>
            </section>
        </form>
        {
            state.showRegister && <form onSubmit={createNewAccount}>
                <section className="h-screen">
                    <div className="h-full bg-gradient-to-r from-blue to-blue-600 flex justify-center items-center">
                        <div className="p-5 bg-white rounded flex flex-col items-center">
                            <div>
                                <img className="object-contain h-20 w-32" src={StaticImage('/images/logoSCGPSolidBlac-removebg-preview.png')} />
                            </div>
                            <div>
                                <h1 className="font-bold text-3xl">Create new account</h1>
                            </div>
                            <span className="text-base text-gray">{t('login.welcome')}</span>
                            <input value={state.email}
                                onChange={(e) => {
                                    setstate({ ...state, email: e.target.value })
                                }} required className="form-control w-72 mt-2" placeholder="Username" type="text" disabled={!state.showLogin} />
                            <input value={state.password}
                                onChange={(e) => {
                                    setstate({ ...state, password: e.target.value })
                                }} required className="form-control w-72 mt-1" placeholder="Password" type="password" />
                            <input value={state.confirmPassword}
                                onChange={(e) => {
                                    setstate({ ...state, confirmPassword: e.target.value })
                                }} required className={`${state.showLogin ? "hidden" : ""} form-control w-72 mt-1`} placeholder="Confirm Password" type="password" />
                            <input value={state.driverName}
                                onChange={(e) => {
                                    setstate({ ...state, driverName: e.target.value })
                                }} required className={`${state.showLogin ? "hidden" : ""} form-control w-72 mt-1`} placeholder="Driver Name" type="text" />
                            <input value={state.phoneNumber}
                                onChange={(e) => {
                                    if (validateNumber(e.target.value)) {
                                        setstate({ ...state, phoneNumber: e.target.value })
                                        if (validatePhonenumber(e.target.value)) {
                                            setstate({ ...state, messageError: t('login.phoneFormatError') })
                                        } else {
                                            setstate({ ...state, messageError: '' })
                                        }
                                    }
                                }} required className={`${state.showLogin ? "hidden" : ""} form-control w-72 mt-1`} placeholder="Phone number" type="text" />
                            {state.messageError && <label className="text-red">{state.messageError}</label>}
                            <button type="submit" className="btn-red w-72 mt-2">Create new account</button>
                            <button type="button" onClick={(e) => { setstate({ ...state, showLogin: true }) }} className="btn-red w-72 mt-2">Sign in</button>
                        </div>
                    </div>
                </section>
            </form>
        }
        {
            state.showChangePassword && <form onSubmit={changePassword}>
                <section className="h-screen">
                    <div className="h-full bg-gradient-to-r from-blue to-blue-600 flex justify-center items-center">
                        <div className="p-5 bg-white rounded flex flex-col items-center">
                            <div>
                                <img className="object-contain h-20 w-32" src={StaticImage('/images/logoSCGPSolidBlac-removebg-preview.png')} />
                            </div>
                            <div>
                                <h1 className="font-bold text-3xl">Change Password</h1>
                            </div>
                            <span className="text-base text-gray">{t('login.welcome')}</span>
                            <div className="form-field w-72 mt-2">
                                <input value={state.email}
                                    onChange={(e) => {
                                        setstate({ ...state, email: e.target.value })
                                    }} required className="form-control w-full" placeholder=" " type="text" disabled={!state.showLogin} />
                                <label>Username</label>
                            </div>
                            <div className="form-field w-72 mt-1">
                                <input value={state.password}
                                    onChange={(e) => {
                                        setstate({ ...state, password: e.target.value })
                                    }} required className="form-control w-full" placeholder=" " type="password" />
                                <label>Password</label>
                            </div>
                            <div className={`${state.showLogin ? "hidden " : ""}form-field w-72 mt-1`}>
                                <input value={state.newPassword}
                                    onChange={(e) => {
                                        setstate({ ...state, newPassword: e.target.value })
                                    }} required className="form-control w-full" placeholder=" " type="password" />
                                <label>New Password</label>
                            </div>
                            <div className={`${state.showLogin ? "hidden " : ""}form-field w-72 mt-1`}>
                                <input value={state.confirmPassword}
                                    onChange={(e) => {
                                        setstate({ ...state, confirmPassword: e.target.value })
                                    }} required className="form-control w-full" placeholder=" " type="password" />
                                <label>Confirm Password</label>
                            </div>
                            {state.messageError && <label className="text-red">{state.messageError}</label>}
                            <button type="submit" className="btn-red w-72 mt-2">Change Password</button>
                            <button type="button" onClick={(e) => { setstate({ ...state, showLogin: true, showRegister: false, showChangePassword: false }) }} className="btn-red w-72 mt-2">Sign in</button>
                        </div>
                    </div>
                </section>
            </form>
        }
    </>
}
export default LoginSuccess;  
